import React, { useCallback, useRef, useState } from 'react';
import { CustomLogicPopupContainer } from './styles';
import TextBlockWithQuillRenderer from '../../ComplexDocumentDesign/TextBlockWithQuillRenderer';
import {
  constructAutoSaveJSON,
  constructQuillJSON,
  convertContractToReact,
} from '../../../utils/TextBlockHelper';
import {
  COMPLEX_DOCUMENT_CONTEXT_KEYS,
  useDocumentContext,
} from '../../../context/complexDocumentContext';
import { Card, Button } from 'antd';
import { dummyCallback } from '../../../utils/complexDocumentConstants';
import { useTranslation } from 'react-i18next';
import { CUSTOM_LOGIC_POPUP } from './translationValues';

const NAMESPACES = ['CUSTOM_LOGIC_POPUP'];

const DEFAULT_VALUE = [
  {
    contentType: 'PARAGRAPH',
    content: '',
  },
  {
    contentType: 'LINE_BREAK',
    content: '\n',
  },
];

const CustomLogicPopup = props => {
  const { t } = useTranslation(NAMESPACES);
  const { position, contents = [], disabled = false, editable } = props;
  const contentsRef = useRef({ contents });

  const customVarSelector = useCallback(
    store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.GLOBAL_VARIABLES],
    [],
  );
  const [globalVariables] = useDocumentContext(
    customVarSelector,
    `AccessibilitySummaryEditor`,
  );

  const styleSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.STYLES], []);
  const [documentStyle] = useDocumentContext(styleSelector, 'AccessibilitySummaryEditor');
  const [textEditable, setTextEditable] = useState(false);
  const [_, setForceRefresh] = useState(0);

  const updateSummaryContents = useCallback(
    (contents, undoDiff, redoDiff, cb, ref, op = undefined, newGlobalVariables = []) => {
      const newContents = constructAutoSaveJSON(
        contents,
        documentStyle?.fontFamily,
        documentStyle?.fontSize,
        newGlobalVariables,
      );
      contentsRef.current = Object.assign({}, contentsRef.current, {
        contents: newContents,
        newGlobalVariables,
      });
      setForceRefresh(key => key + 1);
    },
    [],
  );

  const defaultContent = constructQuillJSON(
    contents?.length > 0 ? contents : DEFAULT_VALUE,
    documentStyle?.fontFamily,
    documentStyle?.fontSize,
    globalVariables,
  );

  const onSaveChanges = useCallback(() => {
    props.onSaveChanges(contentsRef.current);
  }, [props.onSaveChanges]);

  const hasContent = contentsRef?.current?.contents ? contentsRef.current.contents.some(
    item => item.content?.trim() && item.content.trim() !== '\n'
  ) : false;


  return (
    <div
      style={{
        position: position ? 'absolute' : 'relative',
        left: position ? `${position.left}px` : undefined,
        top: position ? `${position.bottom + 10}px` : undefined,
        zIndex: 10000,
      }}
    >
      <Card style={{ background: 'black', borderRadius: '8px' }}>
        <p style={{ color: 'white', fontWeight: '600' }}>{t(
          CUSTOM_LOGIC_POPUP.LOGIC_TITLE.key,
          CUSTOM_LOGIC_POPUP.LOGIC_TITLE.value,
        )}</p>
        <CustomLogicPopupContainer isTextBox={true} showVariableList={true}>
          <div style={{ position: 'relative' }} className={disabled && 'disabled-editor'}>
            <div id={`custom-logic-toolbar`} style={{ visibility: 'hidden', height: 0 }} />
            <div id={`custom-logic-variable`} style={{ position: 'relative', top: 10 }} />
            <TextBlockWithQuillRenderer
              defaultContent={defaultContent}
              saveBlock={updateSummaryContents}
              itemUUID={'custom-logic'}
              selected={editable}
              enableSideBar={dummyCallback}
              enableAI={false}
              toolbarInvisible={true}
              adjustScroll={dummyCallback}
              toolbarDOM={`custom-logic-toolbar`}
              variableDOM={`custom-logic-variable`}
              textEditable={textEditable}
              setTextEditable={setTextEditable}
              customClassName={'custom-logic-editor'}
              getEditorContentLength={dummyCallback}
              backgroundColor={'white'}
              isMailSubject={true}
              onContainerSingleClick={dummyCallback}
              customizeHistory={false}
              border_radius={'4px'}
              exposeRef={false}
            >
              {!editable &&
                !textEditable &&
                convertContractToReact(
                  contents || [],
                  documentStyle?.fontFamily,
                  documentStyle?.fontSize,
                  globalVariables,
                )}
            </TextBlockWithQuillRenderer>
          </div>
          <Button style={{ opacity: hasContent ? 1 : 0.5,pointerEvents:hasContent?'auto':'none',background: '#FFEB3B', width: '32%', fontWeight: '600', color: 'black', border: 'none', borderRadius: '6px', marginTop: '8px', float: 'right' }} onClick={() => {
            onSaveChanges();
          }}> {contents?.length > 0 ? t(
            CUSTOM_LOGIC_POPUP.UPDATE_BUTTON.key,
            CUSTOM_LOGIC_POPUP.UPDATE_BUTTON.value,
          ) : t(
            CUSTOM_LOGIC_POPUP.SAVE_BUTTON.key,
            CUSTOM_LOGIC_POPUP.SAVE_BUTTON.value,
          )}</Button>
        </CustomLogicPopupContainer>
      </Card>
    </div>
  );
};
export default CustomLogicPopup;
